import React from "react";
import ReactGA from "react-ga";
import "./styles/global.css";
import {Switch, Route, withRouter} from "react-router-dom";
import Home from "./pages/Home";
import Embed from "./pages/Embed";
import Edit from "./pages/Edit";
import SignUp from "./pages/SignUp";
import LogIn from "./pages/LogIn";
import ForgotPassword from "./pages/ForgotPassword";
import UpdatePassword from "./pages/UpdatePassword";
import Plans from "./pages/Plans";
import CreateWorkspace from "./components/CreateWorkspace";
import ViewSpotlight from "./pages/ViewSpotlight";
import PrivateRoute from "./router/PrivateRoute";
import Checkout from "./pages/Checkout";
import Invitations from "./pages/Invitations";
import Settings from "./pages/Settings";
import Build from "./pages/Build";
import Pages from "./pages/Pages";
import UTMs from "./pages/UTMs";
import QueryStrings from "./pages/QueryStrings";
import Targeting from "./pages/Targeting";
import {Elements} from "@stripe/react-stripe-js";
import {loadStripe} from "@stripe/stripe-js";

const stripePromise = loadStripe("pk_live_84HDsJ7ZYQyNaumECtiGl53I");

const App = () => {
  ReactGA.pageview(window.location.pathname + window.location.search);

  return (
    <div id="app">
      <Elements stripe={stripePromise}>
        <Switch>
          <PrivateRoute path="/home" component={Home}/>
          <PrivateRoute path="/embed" component={Embed}/>
          <PrivateRoute path="/settings" component={Settings}/>
          <PrivateRoute path="/view" component={ViewSpotlight}/>
          <PrivateRoute path="/edit" component={Edit}/>
          <PrivateRoute path="/checkout/:planId" component={Checkout}/>
          <PrivateRoute path="/plans" component={Plans}/>
          <Route path="/invitations" component={Invitations}/>
          <Route path="/signup/workspace" component={CreateWorkspace}/>
          <Route path="/signup" component={SignUp}/>
          <Route path="/login" component={LogIn}/>
          <Route path="/forgot-password" component={ForgotPassword}/>
          <Route path="/update-password" component={UpdatePassword}/>
          <PrivateRoute path="/build" component={Build}/>
          <PrivateRoute path="/targeting/pages" component={Pages}/>
          <PrivateRoute path="/targeting/utm" component={UTMs}/>
          <PrivateRoute path="/targeting/query-strings" component={QueryStrings}/>
          <PrivateRoute path="/targeting" component={Targeting}/>
          <PrivateRoute path="/" component={Home}/>
        </Switch>
      </Elements>
    </div>
  );
};

export default withRouter(App);
